<template>
    <div>
        <div v-if="showNavBar">
            <Wp_nav_bar :title="title"></Wp_nav_bar>
        </div>
        <div v-if="$common.getLimitPayTime().canPay && $config.project !== 'hm'" style="padding: 10px; margin-top: 10px">
            <van-button type="danger" size="large" @click="payDataDetail">提 款</van-button>
        </div>

        <div>
            <van-tabs v-model="active_whole" sticky title-active-color="#219EFF" color="#219EFF" @change="onChange">
                <van-tab>
                    <div slot="title"><h3>京东</h3></div>
                    <van-tabs v-model="active" sticky :offset-top="44" title-active-color="#ee0a24">
                        <van-tab>
                            <div slot="title"><h3>{{income_title}}</h3></div>
                            <!--                <Wp_order_count :pid="pid"></Wp_order_count>-->
                            <Wp_order_count_new :pid="pid"></Wp_order_count_new>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>{{orders_title}}</h3></div>
                            <Wp_jd_order_flow :time-model-top="88"></Wp_jd_order_flow>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>{{child_title}}</h3></div>
                            <Wp_my_child_member></Wp_my_child_member>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab v-if="$common.canShowTaobao() && $common_tb.getTaobaoPid()">
                    <div slot="title"><h3>淘宝</h3></div>
                    <van-tabs v-model="active_tb" sticky :offset-top="44" title-active-color="#ee0a24">
                        <van-tab>
                            <div slot="title"><h3>预估收入</h3></div>
                            <Wp_tb_order_count_new></Wp_tb_order_count_new>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>订单数据</h3></div>
                            <Wp_tb_order_page :time-model-top="88"></Wp_tb_order_page>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>代理数据</h3></div>
                            <Wp_tb_my_child_member></Wp_tb_my_child_member>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab v-if="$common.canShowPdd() && $common_pdd.getPddPid()">
                    <div slot="title"><h3>拼多多</h3></div>
                    <van-tabs v-model="active_pdd" sticky :offset-top="44" title-active-color="#ee0a24">
                        <van-tab>
                            <div slot="title"><h3>预估收入</h3></div>
                            <Wp_pdd_order_count_new></Wp_pdd_order_count_new>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>订单数据</h3></div>
                            <Wp_pdd_order_page :time-model-top="88"></Wp_pdd_order_page>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>代理数据</h3></div>
                            <Wp_pdd_my_child_member></Wp_pdd_my_child_member>
                        </van-tab>
                    </van-tabs>
                </van-tab>
                <van-tab v-if="$common.canShowMt() && $common_mt.getMtPid()">
                    <div slot="title"><h3>美团</h3></div>
                    <van-tabs v-model="active_mt" sticky :offset-top="44" title-active-color="#ee0a24">
                        <van-tab>
                            <div slot="title"><h3>预估收入</h3></div>
                            <Wp_mt_order_count_new></Wp_mt_order_count_new>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>订单数据</h3></div>
                            <Wp_mt_order_page :time-model-top="88"></Wp_mt_order_page>
                        </van-tab>
                        <van-tab>
                            <div slot="title"><h3>代理数据</h3></div>
                            <Wp_mt_my_child_member></Wp_mt_my_child_member>
                        </van-tab>
                    </van-tabs>
                </van-tab>
            </van-tabs>
        </div>

<!--        <div v-if="$common.canShowTaobao() && $common_tb.getTaobaoPid()">-->
<!--            <div v-if="$common.canShowPdd() && $common_pdd.getPddPid()">-->
<!--                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF" color="#219EFF" @change="onChange">-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>京东</h3></div>-->
<!--                        <van-tabs v-model="active" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{income_title}}</h3></div>-->
<!--                                &lt;!&ndash;                <Wp_order_count :pid="pid"></Wp_order_count>&ndash;&gt;-->
<!--                                <Wp_order_count_new :pid="pid"></Wp_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{orders_title}}</h3></div>-->
<!--                                <Wp_jd_order_flow :time-model-top="88"></Wp_jd_order_flow>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{child_title}}</h3></div>-->
<!--                                <Wp_my_child_member></Wp_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>淘宝</h3></div>-->
<!--                        <van-tabs v-model="active_tb" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>预估收入</h3></div>-->
<!--                                <Wp_tb_order_count_new></Wp_tb_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>订单数据</h3></div>-->
<!--                                <Wp_tb_order_page :time-model-top="88"></Wp_tb_order_page>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>代理数据</h3></div>-->
<!--                                <Wp_tb_my_child_member></Wp_tb_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>拼多多</h3></div>-->
<!--                        <van-tabs v-model="active_pdd" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>预估收入</h3></div>-->
<!--                                <Wp_pdd_order_count_new></Wp_pdd_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>订单数据</h3></div>-->
<!--                                <Wp_pdd_order_page :time-model-top="88"></Wp_pdd_order_page>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>代理数据</h3></div>-->
<!--                                <Wp_pdd_my_child_member></Wp_pdd_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                </van-tabs>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF" color="#219EFF" @change="onChange">-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>京东</h3></div>-->
<!--                        <van-tabs v-model="active" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{income_title}}</h3></div>-->
<!--                                &lt;!&ndash;                <Wp_order_count :pid="pid"></Wp_order_count>&ndash;&gt;-->
<!--                                <Wp_order_count_new :pid="pid"></Wp_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{orders_title}}</h3></div>-->
<!--                                <Wp_jd_order_flow :time-model-top="88"></Wp_jd_order_flow>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{child_title}}</h3></div>-->
<!--                                <Wp_my_child_member></Wp_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>淘宝</h3></div>-->
<!--                        <van-tabs v-model="active_tb" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>预估收入</h3></div>-->
<!--                                <Wp_tb_order_count_new></Wp_tb_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>订单数据</h3></div>-->
<!--                                <Wp_tb_order_page :time-model-top="88"></Wp_tb_order_page>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>代理数据</h3></div>-->
<!--                                <Wp_tb_my_child_member></Wp_tb_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                </van-tabs>-->
<!--            </div>-->
<!--        </div>-->

<!--        <div v-else>-->
<!--            <div v-if="$common.canShowPdd() && $common_pdd.getPddPid()">-->
<!--                <van-tabs v-model="active_whole" sticky title-active-color="#219EFF" color="#219EFF" @change="onChange">-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>京东</h3></div>-->
<!--                        <van-tabs v-model="active" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{income_title}}</h3></div>-->
<!--                                &lt;!&ndash;                <Wp_order_count :pid="pid"></Wp_order_count>&ndash;&gt;-->
<!--                                <Wp_order_count_new :pid="pid"></Wp_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{orders_title}}</h3></div>-->
<!--                                <Wp_jd_order_flow :time-model-top="88"></Wp_jd_order_flow>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>{{child_title}}</h3></div>-->
<!--                                <Wp_my_child_member></Wp_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>拼多多</h3></div>-->
<!--                        <van-tabs v-model="active_pdd" sticky :offset-top="44" title-active-color="#ee0a24">-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>预估收入</h3></div>-->
<!--                                <Wp_pdd_order_count_new></Wp_pdd_order_count_new>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>订单数据</h3></div>-->
<!--                                <Wp_pdd_order_page :time-model-top="88"></Wp_pdd_order_page>-->
<!--                            </van-tab>-->
<!--                            <van-tab>-->
<!--                                <div slot="title"><h3>代理数据</h3></div>-->
<!--                                <Wp_pdd_my_child_member></Wp_pdd_my_child_member>-->
<!--                            </van-tab>-->
<!--                        </van-tabs>-->
<!--                    </van-tab>-->
<!--                </van-tabs>-->
<!--            </div>-->
<!--            <div v-else>-->
<!--                <van-tabs v-model="active" sticky title-active-color="#ee0a24">-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>{{income_title}}</h3></div>-->
<!--                        &lt;!&ndash;                <Wp_order_count :pid="pid"></Wp_order_count>&ndash;&gt;-->
<!--                        <Wp_order_count_new :pid="pid"></Wp_order_count_new>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>{{orders_title}}</h3></div>-->
<!--                        <Wp_jd_order_flow></Wp_jd_order_flow>-->
<!--                    </van-tab>-->
<!--                    <van-tab>-->
<!--                        <div slot="title"><h3>{{child_title}}</h3></div>-->
<!--                        <Wp_my_child_member></Wp_my_child_member>-->
<!--                    </van-tab>-->
<!--                </van-tabs>-->
<!--            </div>-->
<!--        </div>-->

    </div>
</template>

<script>
    import Wp_jd_order_flow from "./Wp_jd_order_flow";
    import Wp_my_child_member from "../pages_childs/Wp_my_child_member";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    import Wp_order_count_new from "../pages_childs/Wp_order_count_new";
    import Wp_tb_order_page from "../tb/pages/Wp_tb_order_page";
    import Wp_tb_order_count_new from "../tb/pages_childs/Wp_tb_order_count_new";
    import Wp_tb_my_child_member from "../tb/pages_childs/Wp_tb_my_child_member";
    import Wp_pdd_order_count_new from "../pdd/pages_childs/Wp_pdd_order_count_new";
    import Wp_pdd_order_page from "../pdd/pages/Wp_pdd_order_page";
    import Wp_pdd_my_child_member from "../pdd/pages_childs/Wp_pdd_my_child_member";
    import Wp_mt_order_count_new from "../meituan/pages_childs/Wp_mt_order_count_new";
    import Wp_mt_order_page from "../meituan/pages/Wp_mt_order_page";
    import Wp_mt_my_child_member from "../meituan/pages_childs/Wp_mt_my_child_member";

    export default {
        name: "Wp_jd_data",
        components: {
            Wp_mt_my_child_member,
            Wp_mt_order_page,
            Wp_mt_order_count_new,
            Wp_pdd_my_child_member,
            Wp_pdd_order_page,
            Wp_pdd_order_count_new,
            Wp_tb_my_child_member,
            Wp_tb_order_count_new,
            Wp_tb_order_page, Wp_order_count_new, Wp_nav_bar, Wp_my_child_member, Wp_jd_order_flow},
        props: {
        },
        data() {
            return {
                active: 0,
                pid:this.$common.getPid(),
                startTime: this.$store.state.startTime,
                endTime: this.$store.state.endTime,

                income_title: "预估收入",
                orders_title: "订单数据",
                child_title: "代理数据",

                showNavBar: false,

                title: "数据",

                active_tb: 0,
                active_pdd: 0,
                active_mt: 0,

                active_whole: 0,
            }
        },
        created() {
            if(this.$common.canShowTaobao() && this.$common_tb.getTaobaoPid()){
                if(this.$common_tb.back_from_count_new){
                    this.active_whole = 2;
                    this.$common_tb.back_from_count_new = false;
                }
                if(this.$common_pdd.back_from_count_new){
                    this.active_whole = 1;
                    this.$common_pdd.back_from_count_new = false;
                }
            }else{
                if(this.$common_pdd.back_from_count_new){
                    this.active_whole = 1;
                    this.$common_pdd.back_from_count_new = false;
                }
            }


            //昨日
            // this.startTime=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
            // this.endTime=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', -1, new Date()));
            //今日
            this.startTime=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));
            this.endTime=this.$common.dateFmt("yyyy-MM-dd", this.$common.dateAdd('d', 0, new Date()));

            this.$store.commit('startTime',this.startTime);
            this.$store.commit('endTime',this.endTime);

            document.documentElement.scrollTop = document.body.scrollTop = 0;

            this.initMiniDatas();
        },

        methods: {

            initMiniDatas(){
                if(this.$route.query && this.$route.query.data_type_parent && typeof (this.$route.query.data_type_parent) !== "undefined"){
                    this.active_whole = Number(this.$route.query.data_type_parent) - 1;

                    this.initDataByActive();

                }else{
                    this.initDataByActive();
                }


            },

            initDataByActive(){
                if(this.$route.query && this.$route.query.data_type && typeof (this.$route.query.data_type) !== "undefined"){
                    let _active = Number(this.$route.query.data_type) - 1;
                    if(this.active_whole === 0){//京东
                        this.active = _active;
                    }else if(this.active_whole === 1){//拼多多
                        this.active_pdd = _active;
                    }else if(this.active_whole === 2){//淘宝
                        this.active_tb = _active;
                    }else if(this.active_whole === 3){//淘宝
                        this.active_mt = _active;
                    }else{
                        this.active_whole = 0;
                        this.active = _active;
                    }

                    this.$log("_active = " + _active)
                    this.showNavBar = true;
                    if(_active === 0){
                        this.title = "我的收益";
                    }else if(_active === 1){
                        this.title = "我的订单";
                    }else if(_active === 2){
                        this.title = "我的代理";
                    }
                }
            },

            onChange(v){
                this.active_whole = v;
            },

            reloadPage() {
                window.location.reload();
            },

            /**
             * 提款
             */
            payDataDetail(){
                //如果是小程序中，则直接打开提款界面
                if(this.$common.gloabl_wx_mini_user_info && this.$common.gloabl_wx_mini_user_info.open_id){
                    this.$router.push('paydata');
                }else{
                    this.$common.pay_from_data_page = true;
                    this.$router.push('my');
                }
            },

        },

        watch:{
            active(newActive){
                if(newActive === 0){
                    this.title = "我的收益";
                }else if(newActive === 1){
                    this.title = "我的订单";
                }else if(newActive === 2){
                    this.title = "我的代理";
                }
            }
        }
    }
</script>

<style scoped>

</style>
